var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchCircle = function SvgSearchCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.378 8.812h.63l3.38 3.396a.842.842 0 0 1 0 1.187.842.842 0 0 1-1.188 0l-3.388-3.387v-.63l-.215-.223a5.181 5.181 0 0 1-4.257 1.18C2.124 9.96.355 8.11.084 5.879A5.185 5.185 0 0 1 5.879.084c2.232.27 4.08 2.04 4.456 4.256a5.182 5.182 0 0 1-1.18 4.257l.223.215Zm-7.74-3.587a3.582 3.582 0 0 0 3.587 3.587 3.582 3.582 0 0 0 3.587-3.587 3.582 3.582 0 0 0-3.587-3.587 3.582 3.582 0 0 0-3.587 3.587Z",
    clipRule: "evenodd"
  })));
};
export default SvgSearchCircle;